import { PickType } from '../../codegen';

import { PromoRegistry } from './promo.registry.entity';

export class PromoActivateDto extends PickType(PromoRegistry, ['code']) {}

export class PromoActivateReturnDto extends PickType(PromoRegistry, [
  'coins',
]) {}
